import { render, staticRenderFns } from "./driver-bind-wx-openId.vue?vue&type=template&id=ddf7527a"
import script from "./driver-bind-wx-openId.vue?vue&type=script&lang=js"
export * from "./driver-bind-wx-openId.vue?vue&type=script&lang=js"
import style0 from "./driver-bind-wx-openId.vue?vue&type=style&index=0&id=ddf7527a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports